import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimesCircle, faBook } from '@fortawesome/free-solid-svg-icons';
import * as HubConstant from '../util/HubConstant';
import { css } from '@emotion/core';
import ClipLoader from 'react-spinners/ClipLoader';

class TableFullTextSearch extends React.Component {
  constructor(props) {
    super(props);
    this.searchBarRef = React.createRef();
    this.state = {
      searchBarFocused: false,
      isInitialClick:false
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.state.isInitialClick) {
      const searchBar = this.searchBarRef.current;
      const folderTreeSideNav = document.getElementsByClassName('FolderTreeSideNav')[0];
      const targetText = event.target.textContent;

      if (searchBar && folderTreeSideNav && !searchBar.contains(event.target) && targetText === this.props.folder.name) {
        this.handleSearchBarUnfocus();
        this.props.setFullTextSearchText('');
      }
      else if (searchBar && !searchBar.contains(event.target) && this.props.fullTextSearchText.trim() === '') {
        this.handleSearchBarUnfocus();
      }
    }
  };

  handleSearchBarUnfocus = () => {
    const { history, location } = this.props;
    if (location.pathname === '/newsfeed/search') {
      history.push('/newsfeed');
    }

    this.setState({ isInitialClick: false });
    this.props.setSearchAreaFocus(HubConstant.HUB_SEARCH_AREA_FOCUS.NONE);
    this.setState({ searchBarFocused: false });
    this.props.setIsFullTextSearchActive(false);
  }
  
  

  handleSearchBarFocus = () => {
    const { history, location } = this.props;
    if (location.pathname !== '/newsfeed/search') {
      history.push('/newsfeed/search');
    }

    this.setState({ isInitialClick: true });
    this.props.setSearchAreaFocus(HubConstant.HUB_SEARCH_AREA_FOCUS.FULL_TEXT_SEARCH);
    this.setState({ searchBarFocused: true });
    this.props.setIsFullTextSearchActive(true);
  };

  handleSearchBarChange = (e) => {
    this.props.setFullTextSearchText(e.target.value);
  };

  keyPressed = (event) => {
    if (event.key === 'Enter') {
      this.props.onReloadObjects(false);
      if (event.target.value === '') {
        this.props.setActivePageName({
          singular: 'Story',
          plural: this.props.folder.name,
          icon: faBook,
        });
        this.handleSearchBarUnfocus();
      }
      else if (this.state.isInitialClick){
        this.props.setActivePageName({
          singular: 'Story',
          plural: 'Global Search',
          icon: faBook,
        });
        this.state.isInitialClick = false;
      }
    }
  };

  render() {
    const collapsibleLoaderOverride = css`
      position: relative;
      margin-top: 3%;
    `;

    return (
      <div className='fullTextSearchDiv'>
        <Row className='structureRow'>
          <Col xs='12'> 
            {this.props.fullTextSearchText === '' ? (
              <FontAwesomeIcon className='fullTextSearchPlaceholderIcon' icon={faSearch} />
            ) : (
              <FontAwesomeIcon
                className='fullTextSearchPlaceholderClear'
                icon={faTimesCircle}
                onClick={async () => {
                  await this.props.setFullTextSearchText('');
                  this.handleSearchBarUnfocus();
                  this.props.onReloadObjects(true);
                  this.props.setActivePageName({
                    singular: 'Story',
                    plural: this.props.folder.name,
                    icon: faBook,
                  });
                }}
              />
            )}

            <Form.Control
              type='text'
              className={`fullTextSearchBar ${
                this.props.searchAreaFocus === HubConstant.HUB_SEARCH_AREA_FOCUS.FILTER ? 'disabled' : ''
              } `}
              placeholder={
                this.props.searchAreaFocus !==
                HubConstant.HUB_SEARCH_AREA_FOCUS.FILTER
                  ? 'Global Search'
                  : 'Search is disabled while filtering, please clear filters before searching.'
              }
              value={this.props.fullTextSearchText}
              onChange={this.handleSearchBarChange}
              onKeyPress={this.keyPressed}
              disabled={this.props.searchAreaFocus === HubConstant.HUB_SEARCH_AREA_FOCUS.FILTER || !!this.props.isLoading}
              onFocus={this.handleSearchBarFocus}
              ref={this.searchBarRef}
            />

            <div className='fullTextSearchRightPanel'>
              <Button
                className='fullTextSearchButton'
                onClick={() => {
                  this.props.onReloadObjects(false);
                }}
                disabled={
                  this.props.isLoading ||
                  this.props.searchAreaFocus === HubConstant.HUB_SEARCH_AREA_FOCUS.FILTER ||
                  this.props.fullTextSearchText === ''
                }
              >
                {this.props.isLoading ? (
                  <ClipLoader size={20} color='#f69b1d' css={collapsibleLoaderOverride} />
                ) : (
                  'Search'
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}


export default withRouter(TableFullTextSearch);
